module.exports = __webpack_public_path__ + "img/3.34532a01.jpg";